import { Component, Input, OnChanges, SimpleChanges, ElementRef, NgZone, OnDestroy, AfterViewInit } from '@angular/core';
import { ObjectUtils } from '../../../../utils/object.utils';
import { chartConfig } from '../../../../app.constants';

@Component({
    selector: 'performance-timeline',
    templateUrl: './performance-timeline.component.html',
    styleUrls: ['./performance-timeline.component.scss']
})
export class PerformanceTimelineComponent implements OnChanges, AfterViewInit, OnDestroy {
    public hasNoData: boolean;
    public placeholderData = [
        {
            name: 'Impressions',
            data: [],
            color: '#717D8D'
        },
        {
            name: 'Reach',
            data: [],
            color: '#717D8D'
        },
        {
            name: 'Engagement',
            data: [],
            color: '#717D8D'
        }
    ];

    public areaFillColor = {
        linearGradient: {
            x1: 0.5,
            y1: 0.4461,
            x2: 0.5,
            y2: 0.9806
        },
        stops: [
            [0, '#EEF2F57F'],
            [1, `#FFFFFF00`]
        ]
    };
    public readonly overridenTooltipConfig = {
        useHTML: false,
        padding: 4,
        borderRadius: 6,
        borderWidth: 6,
        borderColor: chartConfig.tooltipBackgroundColor,
        style: {
            color: chartConfig.lineChart.tooltipColor,
            fontFamily: chartConfig.font.light,
            fontSize: '12px'
        }
    };
    public drawnData: any[];

    private _tooltipInterval;

    @Input() isFetchingData: boolean;
    @Input() title: string;
    @Input() chartData: Array<object> = [];

    constructor(private _hostElRef: ElementRef, private _ngZone: NgZone) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.chartData) {
            const chartData = changes.chartData.currentValue;
            const showPlaceholder = this.shouldShowPlaceholder(chartData);

            if (showPlaceholder) {
                this.hasNoData = true;
                this.stopTooltipInterval();
                return;
            }

            this.drawnData = this.enrichChartData(chartData);
            this.hasNoData = false;
            this.refreshTooltipInterval();
        }
    }

    ngAfterViewInit(): void {
        this.refreshTooltipInterval();
    }

    ngOnDestroy(): void {
        this.stopTooltipInterval();
    }

    private stopTooltipInterval() {
        if (this._tooltipInterval) {
            clearInterval(this._tooltipInterval);
        }
    }

    private refreshTooltipInterval() {
        this.stopTooltipInterval();
        this._ngZone.runOutsideAngular(() => {
            this._tooltipInterval = setInterval(() => {
                const hostEl = this._hostElRef && this._hostElRef.nativeElement;

                if (hostEl) {
                    const textEl = hostEl.querySelector('.highcharts-tooltip > text');

                    if (textEl) {
                        textEl.setAttribute('y', 14);
                        clearInterval(this._tooltipInterval);
                    }
                }
            }, 10);
        });
    }

    private shouldShowPlaceholder(chartData: any[]) {
        return !Array.isArray(chartData)
            || chartData.length === 0
            || !chartData.some(x => Array.isArray(x.data) && x.data.length > 0);
    }

    private enrichChartData(source: any[]) {
        const results = ObjectUtils.deepClone(source);

        results.forEach(x => {
            x.type = 'area';
            x.lineWidth = 4;
            x.marker.radius = 4;
            x.marker.enabled = true;
        });

        return results;
    }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/performance-timeline/performance-timeline.component.ts